import { Container, Button,Form, Alert, Modal, Table} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "./ContentStyles";
import {Pageheight} from "../index";
import React, {useMemo, useState, useEffect } from 'react';
import { FaFilePdf, FaCheck, FaEuroSign, FaShare, FaEdit} from 'react-icons/fa';
import useBackend, {CallAPI, Loading, SpinnerX, Check } from '../services/useBackend_v2';
import {SplitoutLocalDateFromISO, DateTimeToLocal} from '../services/misc';
import {MaterialReactTable} from 'material-react-table';

export default function Projects() {
    const [registrationModalshow, setRegistrationModalshow] = useState(false);
    const [projectDetailsModalshow, setProjectDetailsModalshow] = useState(false);
    const [projectToEdit, setProjectToEdit] = useState({comment:''});
    
    const initRegistrationModal = () => { return setRegistrationModalshow(!registrationModalshow) } 
    const initProjectDetailsModal = () => { return setProjectDetailsModalshow(!projectDetailsModalshow) } 
    
    const {loading, data, Update, Refresh, initReady, resultText, resultVariant, resultVisible, spinnerHidden} =  useBackend(process.env.PUBLIC_URL+'/backend/projects');

    async function UpdateClickHandler(CloseProject=false) {
        const ProductForm = document.getElementById('FrmProjectUpdate');
        const formData = new FormData(ProductForm);
        const formDataObj = Object.fromEntries(formData.entries());
        formDataObj.Closed = CloseProject;
        await Update(formDataObj, 'PATCH', 3000, "/backend/Projects/" + projectToEdit.guid);
        Refresh();
        //e.target.reset() ;      
    }
    
    async function RegistrationAdd() {
        const RegistrationForm = document.getElementById('FrmRegistration');
        const formData = new FormData(RegistrationForm);
        const formDataObj = Object.fromEntries(formData.entries());

        console.log(JSON.stringify(formDataObj));
        let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI("/backend/projects/"+projectToEdit.guid,"POST", JSON.stringify(formDataObj));

        Refresh();
        RegistrationForm.reset() ;      
    }
    
    async function DetailsClickHandler(event, row) {
        setProjectToEdit(row);
        initProjectDetailsModal();
    }


    
    async function InvoiceClickHandler(event) {
        event.preventDefault();
        let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI("/backend/projects/"+projectToEdit.guid+"/invoice","PUT");
        Refresh();     
    }

    const columns = useMemo(() => [
        { size: 20, accessorKey: 'reference', header: '#', enableColumnActions: false, enableHiding:false },
        { size: 100, accessorKey: 'name', header: 'Description' },
        { size: 20, header: 'Start date', enableColumnActions: false,
            Cell: ({ row }) => ( <span>{DateTimeToLocal(row.original.startDate)}</span> ),
        },
        { size: 20, header: 'Closed date', enableColumnActions: false,
            Cell: ({ row }) => ( row.original.closed && <span>{DateTimeToLocal(row.original.closeDate)}</span> ),
        },                      
        { size: 100, accessorKey: 'contact.name',     header: 'Contact', headerClassName: 'test_'},     
        { size: 100, accessorKey: 'amountUninvoiced',     header: 'Uninvoiced', headerClassName: 'test_'},     
      ]
    );  

    const state = {};  
    const initialState={ density: 'compact', pagination: { pageIndex: 0, pageSize: 100 }, columnVisibility: { Company: false, Description:true } }    
    
    if (initReady) {
        return (
            <ContentWrapper>
                <Container>
                <Sida style={{minHeight:Pageheight(400)}}>
                    <Button variant="danger" onClick={() => alert("Not implemented, use Postman")}>+</Button>
                    <StyckeCompact>
                        <MaterialReactTable  columns={columns} data={data.projects} 
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            renderTopToolbarCustomActions={() => (<Rubrik>Projects</Rubrik>)} initialState={initialState} state={state} 
                                muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                                
                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => { DetailsClickHandler(event, row.original);},
                                    sx: { cursor: 'pointer' },
                                })}
                        /><br></br>
                        <Alert variant="danger"  className="FormSpace">Total amount uninvoiced: {data.totalAmountUninvoiced}</Alert>
                        <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>
                    </StyckeCompact>

                    <Modal show={registrationModalshow} onHide={initRegistrationModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Registrera Tid/matrial</Modal.Title>                            
                        </Modal.Header>                            
                        <Modal.Body>
                                <div style={{width:"90%"}}>
                                    <Form id="FrmRegistration">                                
                                        <Form.Group className="mb-3">
                                        <Form.Label>Product</Form.Label>
                                        <Form.Select name='ProductId'>
                                            <option value={0}>Select</option>
                                            <option value={1962}>Konsulttid DBA</option>
                                            <option value={971}>Konsulttid Utveckling</option>
                                            <option value={1952}>Konsulttid Diverse</option>
                                            <option value={2004}>Installation/Ominstallation dator</option>
                                            <option value={2041}>Konsulttid Möte</option>
                                            <option value={2042}>Konsulttid Akut/Jour</option>
                                            <option value={2043}>Fastpris</option>
                                            <option value={2048}>Konsulttid DK</option>
                                            <option value={2047}>km (EV) MBP08U DK</option>
                                            <option value={2046}>Restid DK</option>
                                            <option value={2045}>Utlägg DK</option>
                                            </Form.Select>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>DoneDate</Form.Label>
                                            <Form.Control type="date" name="DoneDate" placeholder="utfört Datum" defaultValue={Date.now()} />
                                        </Form.Group>                                        

                                        <Form.Group className="mb-3">
                                            <Form.Label>Qty</Form.Label>
                                            <Form.Control type="text" name ="Qty" placeholder="Qty"  defaultValue={1}/>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Price</Form.Label>
                                            <Form.Control type="text" name ="Price" placeholder="Price"  defaultValue={1250}/>
                                        </Form.Group>

                                        <Form.Group className="mb-3">
                                            <Form.Label>Comment</Form.Label>
                                            <Form.Control type="text" name ="Comment" placeholder="Comment" />
                                        </Form.Group>                                
                                    </Form> 
                                </div>

                            <Form.Group className="mb-3"  hidden={spinnerHidden}>
                                <SpinnerX  />
                            </Form.Group>                      

                            <Form.Group className="mb-3"  hidden={!resultVisible}>
                                <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                            </Form.Group>                               

                        </Modal.Body>

                        <Modal.Footer>
                            <Button className="CloudButton" variant="primary" type="button" onClick={RegistrationAdd}>Spara</Button>
                            <Button variant="danger" onClick={initRegistrationModal}>Avbryt</Button>                            
                        </Modal.Footer>                            
                    </Modal>                    

                    <Modal show={projectDetailsModalshow} onHide={initProjectDetailsModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>Uppdatera Tid/matrial</Modal.Title>                            
                        </Modal.Header>                            
                        <Modal.Body>
                                <div style={{width:"90%"}}>
                                    <Form id="FrmProjectUpdate">                                    
                                        <Form.Group className="mb-3">
                                            <Form.Label>Project</Form.Label>
                                            <Form.Control type="text" name ="Name" placeholder="Name" defaultValue={projectToEdit.name}/>
                                        </Form.Group>                                        

                                        <Form.Group className="mb-3">
                                            <Form.Label>Reference</Form.Label>
                                            <Form.Control type="text" name ="Reference" placeholder="Reference" defaultValue={projectToEdit.reference}/>
                                        </Form.Group>                      
                                    </Form> 
                                </div>

                            <Form.Group className="mb-3"  hidden={!loading}>
                                <SpinnerX  />
                            </Form.Group>                    

                            <Form.Group className="mb-3"  hidden={!resultVisible}>
                                <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert> 
                            </Form.Group>                               
                        </Modal.Body>

                        <Modal.Footer>
                            <Button className="CloudButton" variant="primary" type="button" onClick={initRegistrationModal}>Reg</Button>            
                            <Button className="CloudButton" variant="primary" type="button" onClick={InvoiceClickHandler}>Invoice project</Button>                                            
                            <Button className="CloudButton" variant="primary" type="button" onClick={() => UpdateClickHandler(false)}>Save</Button>            
                            <Button className="CloudButton" variant="primary" type="button" onClick={() => UpdateClickHandler(true)}>Close project</Button>                            
                        </Modal.Footer>                            
                    </Modal>  
                </Sida>
                </Container>
            </ContentWrapper>    
        );        
    } else {
        return (<Loading />);        
    }
}